import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Household } from "../../shared/models/household.model";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class HouseholdService {
  private static readonly BASE_URL = `${environment.apiUrl}/households`;

  constructor(private http: HttpClient) {}

  getUserHouseholds(): Observable<Household[]> {
    return this.http.get<Household[]>(HouseholdService.BASE_URL);
  }
}
